import { Select } from 'antd';
import type { SelectProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useActiveLanguages } from '@features/languages/useLanguages';

interface LanguagePickerProps {
  value?: string | null;
  onChange: (languageId: string | undefined) => void;
  /** Filtrelerde kullanım için "Tüm diller" boş seçeneği ekler. */
  allowClear?: boolean;
  disabled?: boolean;
  placeholder?: string;
  size?: SelectProps['size'];
  style?: React.CSSProperties;
  className?: string;
}

/**
 * Aktif içerik dilleri arasından seçim — create formlarında (içerik dili) ve
 * list filtrelerinde (languageId) paylaşılan seçici. Diller aktif katalogdan
 * gelir (pasif diller yeni içeriğe atanamaz).
 */
export function LanguagePicker({
  value,
  onChange,
  allowClear,
  disabled,
  placeholder,
  size,
  style,
  className,
}: LanguagePickerProps) {
  const { t } = useTranslation('common');
  const { data: languages = [], isLoading } = useActiveLanguages();

  return (
    <Select<string>
      value={value ?? undefined}
      onChange={(v) => onChange(v ?? undefined)}
      loading={isLoading}
      allowClear={allowClear}
      disabled={disabled}
      placeholder={placeholder ?? t('contentLanguage.placeholder')}
      size={size}
      style={style}
      className={className}
      optionFilterProp="label"
      showSearch
      options={languages.map((l) => ({
        value: l.id,
        label: `${l.name} (${l.code})`,
      }))}
    />
  );
}
